<template>
    <div class="modal-contact">
        <div class="title" :class="options.titleClass" v-html="$translate('WHOSE_CONTACT').replace(/%s/, name)" />
        <div class="body">
            <span class="number">{{ formatNumber }}</span>
            <button @click="copy" class="btn copy-button">
                <i class="material-icons">content_copy</i>
            </button>
        </div>
        <hr class="hor-divider" />
        <button @click="confirm" class="btn-primary" v-html="$translate('CONFIRM')" />
        <hr class="hor-divider" />
        <!-- <button
            v-if="this.$store.getters.me.reviewable === true"
            @click="review"
            class="btn-default"
            v-html="$translate('STORE_REVIEW')"
        /> -->
    </div>
</template>

<script>
export default {
    name: 'ModalContact',
    props: ['options'],
    computed: {
        body() {
            return (this.options || {}).body
        },
        name() {
            return this.body.split(', ')[0]
        },
        number() {
            return this.body.split(', ')[1]
        },
        formatNumber() {
            const isEnglish = /[a-zA-Z]/g.test(this.number)

            if (isEnglish) return this.number

            return this.$options.filters.formatPhoneNumber(this.number)
        },
        storeUrl() {
            return this.$store.getters.me.os === 'ios'
                ? 'https://apps.apple.com/kr/app/%EB%B0%94%EB%8B%90%EB%9D%BC%EB%B8%8C%EB%A6%BF%EC%A7%80/id1219876826'
                : 'https://play.google.com/store/apps/details?id=com.vanillabridge.app'
            // return storeUrl
        },
    },
    methods: {
        copy() {
            this.$copyText(this.number)
            this.$toast.success('번호가 복사되었습니다.')
        },
        confirm() {
            this.$emit('close')
        },
        review() {
            this.$nativeBridge.postMessage({
                action: 'openInAppBrowser',
                value: this.storeUrl,
            })
        },
    },
}
</script>
